import axiosInstance from "@/api/axios-instance";

export async function deletePaymentPage(id: string) {
  const response = await axiosInstance.delete(`/payment-pages/${id}`);
  return response.data;
}
